<script lang="ts" setup>
import Button from "../Button/Button.vue";
import StatusMessage from "../StatusMessage/StatusMessage.vue";

defineProps<{
  buttonLink?: string;
}>();

defineEmits<{
  (e: "to-homepage"): void;
}>();
</script>

<template>
  <StatusMessage
    :title="$t('shared.error.page.notFoundError.title')"
    :text="$t('shared.error.page.notFoundError.text')"
  >
    <template #actions>
      <Button
        v-if="buttonLink"
        :caption="$t('shared.error.page.action.toHomepage')"
        :href="buttonLink"
      />
      <Button
        v-else
        :caption="$t('shared.error.page.action.toHomepage')"
        @click="$emit('to-homepage')"
      />
    </template>
  </StatusMessage>
</template>
